const countries: any = {
  AF: { code: "AF", name: "Afghanistan", continent: "Asia" },
  AL: { code: "AL", name: "Albania", continent: "Europe" },
  DZ: { code: "DZ", name: "Algeria", continent: "Africa" },
  AS: { code: "AS", name: "American Samoa", continent: "Oceania" },
  AD: { code: "AD", name: "Andorra", continent: "Europe" },
  AO: { code: "AO", name: "Angola", continent: "Africa" },
  AI: { code: "AI", name: "Anguilla", continent: "North America" },
  AG: { code: "AG", name: "Antigua and Barbuda", continent: "North America" },
  AR: { code: "AR", name: "Argentina", continent: "South America" },
  AM: { code: "AM", name: "Armenia", continent: "Asia" },
  AW: { code: "AW", name: "Aruba", continent: "North America" },
  AU: { code: "AU", name: "Australia", continent: "Oceania" },
  AT: { code: "AT", name: "Austria", continent: "Europe" },
  AZ: { code: "AZ", name: "Azerbaijan", continent: "Asia" },
  BS: { code: "BS", name: "Bahamas", continent: "North America" },
  BH: { code: "BH", name: "Bahrain", continent: "Asia" },
  BD: { code: "BD", name: "Bangladesh", continent: "Asia" },
  BB: { code: "BB", name: "Barbados", continent: "North America" },
  BY: { code: "BY", name: "Belarus", continent: "Europe" },
  BE: { code: "BE", name: "Belgium", continent: "Europe" },
  BZ: { code: "BZ", name: "Belize", continent: "North America" },
  BJ: { code: "BJ", name: "Benin", continent: "Africa" },
  BM: { code: "BM", name: "Bermuda", continent: "North America" },
  BT: { code: "BT", name: "Bhutan", continent: "Asia" },
  BO: { code: "BO", name: "Bolivia", continent: "South America" },
  BA: { code: "BA", name: "Bosnia and Herzegovina", continent: "Europe" },
  BW: { code: "BW", name: "Botswana", continent: "Africa" },
  BR: { code: "BR", name: "Brazil", continent: "South America" },
  IO: { code: "IO", name: "British Indian Ocean Territory", continent: "Asia" },
  BG: { code: "BG", name: "Bulgaria", continent: "Europe" },
  BF: { code: "BF", name: "Burkina Faso", continent: "Africa" },
  BI: { code: "BI", name: "Burundi", continent: "Africa" },
  KH: { code: "KH", name: "Cambodia", continent: "Asia" },
  CM: { code: "CM", name: "Cameroon", continent: "Africa" },
  CA: { code: "CA", name: "Canada", continent: "North America" },
  CV: { code: "CV", name: "Cape Verde", continent: "Africa" },
  KY: { code: "KY", name: "Cayman Islands", continent: "North America" },
  CF: { code: "CF", name: "Central African Republic", continent: "Africa" },
  TD: { code: "TD", name: "Chad", continent: "Africa" },
  CL: { code: "CL", name: "Chile", continent: "South America" },
  CN: { code: "CN", name: "China", continent: "Asia" },
  CO: { code: "CO", name: "Colombia", continent: "South America" },
  KM: { code: "KM", name: "Comoros", continent: "Africa" },
  CK: { code: "CK", name: "Cook Islands", continent: "Oceania" },
  CR: { code: "CR", name: "Costa Rica", continent: "North America" },
  HR: { code: "HR", name: "Croatia", continent: "Europe" },
  CU: { code: "CU", name: "Cuba", continent: "North America" },
  CW: { code: "CW", name: "Curacao", continent: "North America" },
  CY: { code: "CY", name: "Cyprus", continent: "Europe" },
  CZ: { code: "CZ", name: "Czechia", continent: "Europe" },
  CD: {
    code: "CD",
    name: "Democratic Republic of the Congo",
    continent: "Africa",
  },
  DK: { code: "DK", name: "Denmark", continent: "Europe" },
  DJ: { code: "DJ", name: "Djibouti", continent: "Africa" },
  DM: { code: "DM", name: "Dominica", continent: "North America" },
  DO: { code: "DO", name: "Dominican Republic", continent: "North America" },
  EC: { code: "EC", name: "Ecuador", continent: "South America" },
  EG: { code: "EG", name: "Egypt", continent: "Africa" },
  SV: { code: "SV", name: "El Salvador", continent: "North America" },
  GQ: { code: "GQ", name: "Equatorial Guinea", continent: "Africa" },
  ER: { code: "ER", name: "Eritrea", continent: "Africa" },
  EE: { code: "EE", name: "Estonia", continent: "Europe" },
  ET: { code: "ET", name: "Ethiopia", continent: "Africa" },
  FK: { code: "FK", name: "Falkland Islands", continent: "South America" },
  FO: { code: "FO", name: "Faroe Islands", continent: "Europe" },
  FJ: { code: "FJ", name: "Fiji", continent: "Oceania" },
  FI: { code: "FI", name: "Finland", continent: "Europe" },
  FR: { code: "FR", name: "France", continent: "Europe" },
  PF: { code: "PF", name: "French Polynesia", continent: "Oceania" },
  GA: { code: "GA", name: "Gabon", continent: "Africa" },
  GM: { code: "GM", name: "Gambia", continent: "Africa" },
  GE: { code: "GE", name: "Georgia", continent: "Asia" },
  DE: { code: "DE", name: "Germany", continent: "Europe" },
  GH: { code: "GH", name: "Ghana", continent: "Africa" },
  GI: { code: "GI", name: "Gibraltar", continent: "Europe" },
  GR: { code: "GR", name: "Greece", continent: "Europe" },
  GL: { code: "GL", name: "Greenland", continent: "North America" },
  GD: { code: "GD", name: "Grenada", continent: "North America" },
  GU: { code: "GU", name: "Guam", continent: "Oceania" },
  GT: { code: "GT", name: "Guatemala", continent: "North America" },
  GG: { code: "GG", name: "Guernsey", continent: "Europe" },
  GN: { code: "GN", name: "Guinea", continent: "Africa" },
  GW: { code: "GW", name: "Guinea-Bissau", continent: "Africa" },
  HT: { code: "HT", name: "Haiti", continent: "North America" },
  HN: { code: "HN", name: "Honduras", continent: "North America" },
  HK: { code: "HK", name: "Hong Kong", continent: "Asia" },
  HU: { code: "HU", name: "Hungary", continent: "Europe" },
  IS: { code: "IS", name: "Iceland", continent: "Europe" },
  IN: { code: "IN", name: "India", continent: "Asia" },
  ID: { code: "ID", name: "Indonesia", continent: "Asia" },
  IR: { code: "IR", name: "Iran", continent: "Asia" },
  IQ: { code: "IQ", name: "Iraq", continent: "Asia" },
  IE: { code: "IE", name: "Ireland", continent: "Europe" },
  IM: { code: "IM", name: "Isle of Man", continent: "Europe" },
  IL: { code: "IL", name: "Israel", continent: "Asia" },
  IT: { code: "IT", name: "Italy", continent: "Europe" },
  CI: { code: "CI", name: "Ivory Coast", continent: "Africa" },
  JM: { code: "JM", name: "Jamaica", continent: "North America" },
  JP: { code: "JP", name: "Japan", continent: "Asia" },
  JE: { code: "JE", name: "Jersey", continent: "Europe" },
  JO: { code: "JO", name: "Jordan", continent: "Asia" },
  KZ: { code: "KZ", name: "Kazakhstan", continent: "Asia" },
  KE: { code: "KE", name: "Kenya", continent: "Africa" },
  KI: { code: "KI", name: "Kiribati", continent: "Oceania" },
  KW: { code: "KW", name: "Kuwait", continent: "Asia" },
  KG: { code: "KG", name: "Kyrgyzstan", continent: "Asia" },
  LA: { code: "LA", name: "Laos", continent: "Asia" },
  LV: { code: "LV", name: "Latvia", continent: "Europe" },
  LB: { code: "LB", name: "Lebanon", continent: "Asia" },
  LS: { code: "LS", name: "Lesotho", continent: "Africa" },
  LR: { code: "LR", name: "Liberia", continent: "Africa" },
  LY: { code: "LY", name: "Libya", continent: "Africa" },
  LI: { code: "LI", name: "Liechtenstein", continent: "Europe" },
  LT: { code: "LT", name: "Lithuania", continent: "Europe" },
  LU: { code: "LU", name: "Luxembourg", continent: "Europe" },
  MO: { code: "MO", name: "Macao", continent: "Asia" },
  MK: { code: "MK", name: "Macedonia", continent: "Europe" },
  MG: { code: "MG", name: "Madagascar", continent: "Africa" },
  MW: { code: "MW", name: "Malawi", continent: "Africa" },
  MY: { code: "MY", name: "Malaysia", continent: "Asia" },
  MV: { code: "MV", name: "Maldives", continent: "Asia" },
  ML: { code: "ML", name: "Mali", continent: "Africa" },
  MT: { code: "MT", name: "Malta", continent: "Europe" },
  MH: { code: "MH", name: "Marshall Islands", continent: "Oceania" },
  MQ: { code: "MQ", name: "Martinique", continent: "North America" },
  MR: { code: "MR", name: "Mauritania", continent: "Africa" },
  MU: { code: "MU", name: "Mauritius", continent: "Africa" },
  MX: { code: "MX", name: "Mexico", continent: "North America" },
  FM: { code: "FM", name: "Micronesia", continent: "Oceania" },
  MD: { code: "MD", name: "Moldova", continent: "Europe" },
  MC: { code: "MC", name: "Monaco", continent: "Europe" },
  MN: { code: "MN", name: "Mongolia", continent: "Asia" },
  ME: { code: "ME", name: "Montenegro", continent: "Europe" },
  MS: { code: "MS", name: "Montserrat", continent: "North America" },
  MA: { code: "MA", name: "Morocco", continent: "Africa" },
  MZ: { code: "MZ", name: "Mozambique", continent: "Africa" },
  MM: { code: "MM", name: "Myanmar [Burma]", continent: "Asia" },
  NA: { code: "NA", name: "Namibia", continent: "Africa" },
  NR: { code: "NR", name: "Nauru", continent: "Oceania" },
  NP: { code: "NP", name: "Nepal", continent: "Asia" },
  NL: { code: "NL", name: "Netherlands", continent: "Europe" },
  NZ: { code: "NZ", name: "New Zealand", continent: "Oceania" },
  NI: { code: "NI", name: "Nicaragua", continent: "North America" },
  NE: { code: "NE", name: "Niger", continent: "Africa" },
  NG: { code: "NG", name: "Nigeria", continent: "Africa" },
  NU: { code: "NU", name: "Niue", continent: "Oceania" },
  NF: { code: "NF", name: "Norfolk Island", continent: "Oceania" },
  KP: { code: "KP", name: "North Korea", continent: "Asia" },
  MP: { code: "MP", name: "Northern Mariana Islands", continent: "Oceania" },
  NO: { code: "NO", name: "Norway", continent: "Europe" },
  OM: { code: "OM", name: "Oman", continent: "Asia" },
  PK: { code: "PK", name: "Pakistan", continent: "Asia" },
  PW: { code: "PW", name: "Palau", continent: "Oceania" },
  PS: { code: "PS", name: "Palestine", continent: "Asia" },
  PA: { code: "PA", name: "Panama", continent: "North America" },
  PG: { code: "PG", name: "Papua New Guinea", continent: "Oceania" },
  PY: { code: "PY", name: "Paraguay", continent: "South America" },
  PE: { code: "PE", name: "Peru", continent: "South America" },
  PH: { code: "PH", name: "Philippines", continent: "Asia" },
  PN: { code: "PN", name: "Pitcairn Islands", continent: "Oceania" },
  PL: { code: "PL", name: "Poland", continent: "Europe" },
  PT: { code: "PT", name: "Portugal", continent: "Europe" },
  PR: { code: "PR", name: "Puerto Rico", continent: "North America" },
  QA: { code: "QA", name: "Qatar", continent: "Asia" },
  CG: { code: "CG", name: "Republic of the Congo", continent: "Africa" },
  RO: { code: "RO", name: "Romania", continent: "Europe" },
  RU: { code: "RU", name: "Russia", continent: "Europe" },
  RW: { code: "RW", name: "Rwanda", continent: "Africa" },
  KN: { code: "KN", name: "Saint Kitts and Nevis", continent: "North America" },
  LC: { code: "LC", name: "Saint Lucia", continent: "North America" },
  WS: { code: "WS", name: "Samoa", continent: "Oceania" },
  SM: { code: "SM", name: "San Marino", continent: "Europe" },
  ST: { code: "ST", name: "São Tomé and Príncipe", continent: "Africa" },
  SA: { code: "SA", name: "Saudi Arabia", continent: "Asia" },
  SN: { code: "SN", name: "Senegal", continent: "Africa" },
  RS: { code: "RS", name: "Serbia", continent: "Europe" },
  SC: { code: "SC", name: "Seychelles", continent: "Africa" },
  SL: { code: "SL", name: "Sierra Leone", continent: "Africa" },
  SG: { code: "SG", name: "Singapore", continent: "Asia" },
  SX: { code: "SX", name: "Sint Maarten", continent: "North America" },
  SK: { code: "SK", name: "Slovakia", continent: "Europe" },
  SI: { code: "SI", name: "Slovenia", continent: "Europe" },
  SB: { code: "SB", name: "Solomon Islands", continent: "Oceania" },
  SO: { code: "SO", name: "Somalia", continent: "Africa" },
  ZA: { code: "ZA", name: "South Africa", continent: "Africa" },
  KR: { code: "KR", name: "South Korea", continent: "Asia" },
  SS: { code: "SS", name: "South Sudan", continent: "Africa" },
  ES: { code: "ES", name: "Spain", continent: "Europe" },
  LK: { code: "LK", name: "Sri Lanka", continent: "Asia" },
  SD: { code: "SD", name: "Sudan", continent: "Africa" },
  SR: { code: "SR", name: "Suriname", continent: "South America" },
  SZ: { code: "SZ", name: "Swaziland", continent: "Africa" },
  SE: { code: "SE", name: "Sweden", continent: "Europe" },
  CH: { code: "CH", name: "Switzerland", continent: "Europe" },
  SY: { code: "SY", name: "Syria", continent: "Asia" },
  TW: { code: "TW", name: "Taiwan", continent: "Asia" },
  TJ: { code: "TJ", name: "Tajikistan", continent: "Asia" },
  TZ: { code: "TZ", name: "Tanzania", continent: "Africa" },
  TH: { code: "TH", name: "Thailand", continent: "Asia" },
  TG: { code: "TG", name: "Togo", continent: "Africa" },
  TK: { code: "TK", name: "Tokelau", continent: "Oceania" },
  TO: { code: "TO", name: "Tonga", continent: "Oceania" },
  TT: { code: "TT", name: "Trinidad and Tobago", continent: "North America" },
  TN: { code: "TN", name: "Tunisia", continent: "Africa" },
  TR: { code: "TR", name: "Turkey", continent: "Asia" },
  TM: { code: "TM", name: "Turkmenistan", continent: "Asia" },
  TC: {
    code: "TC",
    name: "Turks and Caicos Islands",
    continent: "North America",
  },
  TV: { code: "TV", name: "Tuvalu", continent: "Oceania" },
  VI: { code: "VI", name: "U.S. Virgin Islands", continent: "North America" },
  UG: { code: "UG", name: "Uganda", continent: "Africa" },
  UA: { code: "UA", name: "Ukraine", continent: "Europe" },
  AE: { code: "AE", name: "United Arab Emirates", continent: "Asia" },
  GB: { code: "GB", name: "United Kingdom", continent: "Europe" },
  US: { code: "US", name: "United States", continent: "North America" },
  UY: { code: "UY", name: "Uruguay", continent: "South America" },
  UZ: { code: "UZ", name: "Uzbekistan", continent: "Asia" },
  VU: { code: "VU", name: "Vanuatu", continent: "Oceania" },
  VE: { code: "VE", name: "Venezuela", continent: "South America" },
  VN: { code: "VN", name: "Vietnam", continent: "Asia" },
  YE: { code: "YE", name: "Yemen", continent: "Asia" },
  ZM: { code: "ZM", name: "Zambia", continent: "Africa" },
  ZW: { code: "ZW", name: "Zimbabwe", continent: "Africa" },
};

export default countries;
